<template>
  <div>
    <!-- {{ selectedItem }} -->
    <div class="cd-info" v-if="selectedItem">{{selectedItem.company_cd }}</div>

    <div class="flex">
      <v-text-field dense outlined 
        class="textfield"
        id="companyData.company_name" 
        ref="company_name"
        label="경영체명*" 
        :disabled="!selectedItem"
        v-model="companyData.company_name" 
      />
      <v-select dense outlined
        ref="company_type" 
        class="selectmid"
        label="경영체유형*"
        v-model="companyData.company_type"
        :items="companyTypeItems"
        :menu-props="{ top: false, offsetY: true }"
        item-text="name"
        :disabled="!selectedItem"
        auto
        return-object
      />
    </div>

    <div class="mt-5">
      <div class="flex">
        <v-text-field dense outlined
          disabled
          class="textfield"
          id="post_no" 
          ref="post_no" 
          label="우편번호✽" 
          v-model="companyData.post_no" 
          onKeyup="this.value=this.value.replace(/[^0-9]/g,'');"
          maxlength="5"
        />
        <v-btn text class="search_btn mt-1"
        @click="openPost()">
          검색
        </v-btn>
      </div>

      <div class="mt-2">
        <v-text-field dense outlined
        disabled
        style="min-width:525px;"
        class="textfield"
        id="address_1st" 
        ref="address_1st" 
        label="기본주소✽" 
        v-model="companyData.address_1st" 
        />
      </div>
      <div class="mt-2">
        <v-text-field dense outlined 
          style="min-width:525px;"
          class="textfield"
          id="address_last" 
          ref="address_last" 
          label="상세주소(빌딩명,동호수,상호)" 
          :disabled="!selectedItem"
          v-model="companyData.address_last" 
        />
      </div>
    </div>

    <div class="mt-5 flex s-bt">
        <v-text-field dense outlined 
          class="textfield"
          id="email_id" 
          ref="email_id" 
          label="이메일" 
          :disabled="!selectedItem"
          v-model="companyData.email_id" 
        />
        <div class="mr-1">
          <img :src="mail" class="mt-5 icon"/>
        </div>
        <v-combobox dense outlined 
          id="email_host" 
          ref="email_host" 
          :disabled="!selectedItem"
          :items="['gmail.com','hotmail.com','naver.com','daum.net',]"
          :menu-props="{ top: false, offsetY: true }"
          placeholder="항목이 없으면 직접 입력하세요"
          v-model="companyData.email_host" 
        />
    </div>

    <div class="mt-5 flex">
      <v-text-field dense outlined
        class="textfield"
        id="phone" 
        ref="phone" 
        label="전화번호" 
        placeholder="숫자만 입력"
        :disabled="!selectedItem"
        v-model="companyData.phone"
        @keyup="getPhoneMask(companyData.phone)"
      />


      <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field dense outlined clearable
            class="textfield"
            id="deldate" 
            ref="deldate" 
            :disabled="!selectedItem"
            v-model="companyData.business_date"
            label="설립일"
            append-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          no-title locale="ko-KR"
          v-model="companyData.business_date"
          @input="menu2 = false"
        ></v-date-picker>
      </v-menu>

    </div>
    <div class="hint-text">
      {{ companyData.hint }}
    </div>

    <div class="mt-5 flex vertical-center" v-if="selectedItem">
      <v-btn
        class="normal-btn mr-3"
        text
        :loading="loadingSave"
        id="save" 
        ref="save" 
        type="submit" 
        @click.prevent="save()"
      >
        수정
      </v-btn>
    </div>
    
  </div>
</template>

<script>
import Apis from '@/api/apis'
import Common from "@/utils/custom/common.js";
import dateUtil from "@/utils/custom/dateProperty.js";

export default{
  name: 'Company',

  props: {
    selectedItem: {
      type: Object,
      default: null,
    },
  },
  watch: {
    selectedItem: {
      immediate: true,
      handler(newValue) {
        if (newValue && Object.keys(newValue).length > 0) {
          this.companyData = { ...this.companyData, ...newValue }; 
        } else {
          this.resetCompnayData(); 
        }
      },
    },
  },
  data:() =>({
    mail: require("@/assets/login/mail.svg"),
    loadingSave:false,

    companyData:{
      company_code:"",
      company_name:'',
      company_type:'',

      post_no : "",
      address_1st : "",
      address_last : "",

      email_id:"",
      email_host:"",

      phone:'',

      business_date:'',
      hint:'',

    },

    companyTypeItems : [],
    menu2: false,
  }),
  created() {
    this.loadDaumPostCode();
    this.listCompanyType();
  },
  methods:{
    loadDaumPostCode() {
      return new Promise((resolve, reject) => {
        if (window.daum && window.daum.Postcode) {
          resolve();
        } else {
          const daumScript = document.createElement('script');
          daumScript.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
          daumScript.async = true;

          daumScript.onload = () => resolve();
          daumScript.onerror = () => reject(new Error('Failed to load Daum Postcode API.'));
          document.head.appendChild(daumScript);
        }
      });
    },
    openPost() {
      this.loadDaumPostCode()
        .then(() => {
          // console.log('Daum Postcode API loaded.');
          new daum.Postcode({
            oncomplete: (data) => {
              // 1. 주소 결과를 farmData에 저장
              this.companyData.post_no = data.zonecode; // 우편번호
              this.companyData.address_1st = data.roadAddress; // 기본주소
              // console.log('Address:', data.roadAddress);
            },
          }).open();
        })
        .catch((error) => {
          console.error('Daum Postcode API 로드 실패:', error.message);
        });
    },
    save(){
      this.$store.commit("resMessage","");
      let msgCheckdata = this.checkData(); 
      if (msgCheckdata){
        this.$store.commit("resMessage",msgCheckdata);
        // alert(msgCheckdata);
        return;
      }
      this.loadingSave = true;
        // console.log('업데이트')
      Apis.updateCompanyFree({
        company_cd: this.companyData.company_code,
        company_name: this.companyData.company_name.trim(),
        company_type: this.companyData.company_type.code,
        // business_no: this.business_no.replace(/[^0-9]/g, ''),
        business_date: this.companyData.business_date,
        post_no: this.companyData.post_no,
        address_1st: this.companyData.address_1st.trim(),
        address_last: this.companyData.address_last.trim(),
        email1: this.companyData.email_id.trim() + "@" + this.email_host, 
        email2: "",
        phone1: this.companyData.phone.replace(/[^0-9]/g, ''),
        phone2: "",
        // deldate: "",
        // service_grade: this.service_grade.code,
        // history: "",
        // etc1: "",
        // etc2: "",
        // etc3: "", 
      },(res) => {  
        if (res.result) {
          this.loadingSave = false;
          this.$store.commit("resMessage",res.message);

          this.$emit("refreshTreeData");
          this.resetCompnayData();
        } else {
          // this.loadingSave = false;
          alert(res.message);
        }
      }).catch( (err) => {  // API 오류 처리
          // this.loadingSave = false;
          console.log("updateCompany API 호출 오류",err)
          alert(err);
      })

    },
    checkData() {
      if (!this.companyData.company_name.trim()) {
        this.$refs.company_name.focus();
        return "경영체명을 입력하세요";
      }
      if (!this.companyData.company_type.code) {
        this.$refs.company_type.focus();
        return "경영체 유형을 선택입력하세요";
      }
      if (!this.companyData.post_no) {
        this.$refs.post_no.focus();
        return "우편번호를 입력하세요";
      }
      if (!this.companyData.address_1st.trim()) {
        this.$refs.address_1st.focus();
        return "기본주소를 입력하세요";
      }
      return "";
    },
    resetCompnayData(){
      this.companyData = {
        company_name:'',
        company_type:'',

        post_no : "",
        address_1st : "",
        address_last : "",

        email_id:"",
        email_host:"",

        phone:'',

        business_date:'',
        hint:'',
      }
    },
    infoDetail(value) {
      // console.log(value)
      Apis.infoCompany({
        company_cd: value.company_cd, 
      },(res) => {
        if (res.result) {
          let email_id = "";
          let email_host = "";

          if (res.data.email1) {
              const email = res.data.email1.split("@", 2);
              email_id = email[0] || ""; 
              email_host = email[1] || ""; 
          }

          // console.log(res.data)
          this.companyData = {
            ...this.companyData,
            company_code:res.data.company_cd,
            company_name:res.data.company_name,
            company_type: {code: res.data.company_type.substring(0,4), name: res.data.company_type.substring(4)},
            
            post_no : res.data.post_no,
            address_1st : res.data.address_1st,
            address_last : res.data.address_last,

            email_id: email_id,
            email_host: email_host,

            phone: Common.getMask(res.data.phone1),

            business_date : res.data.business_date,

            hint : res.data.regdate + "에 등록, " + res.data.chguser + "님이 " + res.data.chgdate + "에 최종 수정"


          }
        } else {
          this.loading = false;
          alert(res.message);
        }
      });
    },
    listCompanyType() {
      // BH 모델
      Apis.baseCodeList({
        // session_id: this.$getters.sessionId,
        division: "CM", 
        },(res) => {  
          if (res.result) {
            this.companyTypeItems = [];
            for (let i in res.data) {
            this.companyTypeItems.push({
              code: res.data[i].basecode,
              name: res.data[i].description,
              });
            }  
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("API 호출 오류")
            alert(err);
            // console.log(err)
        }
      ) 
    },
    updateSelectedCompany(selectedCompany) {
      this.$emit("update:selectedCompany", selectedCompany?.code || null);
    },
    getPhoneMask(val) {
      // console.log(val)
      this.companyData.phone = Common.getMask(val)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../info_style/info_style.scss';
.color-info{
  font-size:14px;
}
.detail_info{
  border:1px solid #eeeeee;
  padding:10px;
  border-radius: 10px;
}
</style>